import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Toggle from '../../Common/Toggle/Toggle';

export default class StatusForm extends React.Component {

    constructor(props, context) {
        super(props, context);

    }

    onTextChange = (e) => {
        this.props.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.props.onFormChange(name, value);
    }

    onCoreStatusChange = (id) => {
        this.props.onFormChange("coreStatusId", id);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit();
        return false;
    }

    isCoreStatusNotStarted = () => {
        const coreStatus = this.props.coreStatuses.find(x => x.id === this.props.status.coreStatusId);
        if (coreStatus && coreStatus.name) {
            return (coreStatus.name.toLowerCase() === "not started") ? true : false;
        }
        return false;
    }

    render() {

        const alertDefaultClassList = (this.props.showDefaultWarning) ? "alert alert-danger" : "d-none";
        const alertInactiveClassList = (this.props.showInactiveWarning) ? "alert alert-danger" : "d-none";

        return (
            <div className="identifier-form">
                <form noValidate className={this.props.isFormValid ? "" : "was-validated"} onSubmit={this.onSubmit}>
                    <InputText name="name" label="Name" placeholder="Name" type="text" value={this.props.status.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" />
                    <MultiSelectBox
                        name="coreStatuses"
                        label="Core Status"
                        options={this.props.coreStatuses}
                        idField="id"
                        valueField="name"
                        selectedValues={this.props.status.coreStatusId.toString()}
                        onChange={this.onCoreStatusChange}
                        errorMessage="Core Status is required"
                        isRequired={true}
                        isMulti={false}
                    />
                    <Toggle name="isActive" text="Active" checked={this.props.status.isActive} onChange={this.onToggleChange} />
                    {this.isCoreStatusNotStarted()
                        ?
                        <Toggle name="defaultNotStarted" text="Default Not Started" checked={this.props.status.defaultNotStarted} onChange={this.onToggleChange} />
                        :
                        ""
                    }

                    <div id="alertDefaultClassList" className={alertDefaultClassList} role="alert">You cannot deactivate Default Not Started from a Status. You must choose another Status and set that as Default Not Started.</div>
                    <div id="alertInactiveClassList" className={alertInactiveClassList} role="alert">You cannot deactivate a Status that is marked as Default Not Started.</div>
                    
                </form>
            </div>
        );
    }

}

StatusForm.propTypes = {
    coreStatuses: PropTypes.array.isRequired,
    onFormChange: PropTypes.func.isRequired, // returns (field, value)
    isFormValid: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    showInactiveWarning: PropTypes.bool.isRequired,
    showDefaultWarning: PropTypes.bool.isRequired,
    status: PropTypes.object
}
